import es from '../i18n/crm/es.json';

// Standalone Backoffice translations; no runtime imports from Electron.
// Other locales are available for future Backoffice language selection.
export const crmText = es;
const locales = import.meta.glob('../i18n/crm/*.json', {eager:true,import:'default'});
export const crmLocale = language => locales[`../i18n/crm/${String(language||'en').toLowerCase().split(/[-_]/)[0]}.json`] || locales['../i18n/crm/en.json'];
// Textos del email (los mismos que usa el Worker): la etiqueta del botón para reagendar.
const mailLocales = import.meta.glob('../i18n/mail/*.json', {eager:true,import:'default'});
export const mailLocale = language => mailLocales[`../i18n/mail/${String(language||'en').toLowerCase().split(/[-_]/)[0]}.json`] || mailLocales['../i18n/mail/en.json'];
export const rescheduleLabels = Object.values(mailLocales).map(copy => copy.rescheduleCta).filter(Boolean);
// «Agendar llamada» en todos los idiomas: la línea de «Invitar a una reunión».
export const bookingLabels = Object.values(mailLocales).map(copy => copy.bookingCta).filter(Boolean);
export const stageLabel = (settings, id) => settings?.stages?.find(s => s.id === id)?.label || crmText[id] || id;
